













import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { setStorage } from "@common/utils";
import Menu from "@/zh-website/src/components/website/Menu.vue";
import BottomFoot from "@/zh-website/src/components/website/BottomFoot.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
@Component({
  components: {
    Menu,
    BottomFoot,
    SideBar
  }
})
export default class Index extends Vue {
  inHome = false;
  @Watch("$route", { immediate: true })
  onRouteChange(route) {
    this.inHome = route.name === "home";
  }
  mounted() {
    // 添加用于判断是 c端 还是 b端的 local storage
    setStorage("ictType", "zh-website");
  }
}
